import Vue from "vue";
import VueRouter from "vue-router";
import benefitIndex from "@/components/benefitIndex.vue";
import checkAJB from "../utils/JSBridge";
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		redirect: "/benefitIndex"
	},
	{
		path: "/benefitIndex",
		name: "benefitIndex",
		component: benefitIndex,
		meta: {
			title: "社会保障"
		}
	},
	{
		path:'/XybgIndex',
		name:'XybgIndex',
		component: () => import('@/views/xybg/XybgIndex.vue'),
		meta: {
			title: "信用报告查询"
		}
	},
	{
		path:'/XybgSearch',
		name:'XybgSearch', 
		component: () => import('@/views/xybg/XybgSearch.vue'),
		meta: {
			title: "信用报告查询"
		}
	},
	{
		path:'/firmmsgSearch',
		name:'firmmsgSearch', 
		component: () => import('@/views/firmmsg/FirmmsgSearch.vue'),
		meta: {
			title: "中小企业信息查询"
		}
	},
	{
		path:'/firmmsgIndex',
		name:'firmmsgIndex', 
		component: () => import('@/views/firmmsg/FirmmsgIndex.vue'),
		meta: {
			title: "中小企业信息查询"
		}
	},
	
	{
		path:'/CheckName',
		name:'CheckName', 
		component: () => import('@/views/checkname/CheckName.vue'),
		meta: {
			title: "重名查询"
		}
	},	
	{
		path:'/chuangwenIndex',
		name:'chuangwenIndex', 
		component: () => import('@/views/chuangwen/index.vue'),
		meta: {
			title: "创文助手"
		}
	},
	{
		path:'/chuangwenXuanze',
		name:'chuangwenXuanze', 
		component: () => import('@/views/chuangwen/xuanze.vue'),
		meta: {
			title: "创文助手"
		}
	},
	{
		path:'/chuangwenChaxun',
		name:'chuangwenChaxun', 
		component: () => import('@/views/chuangwen/chaxun.vue'),
		meta: {
			title: "创文助手"
		}
	},
	{
		path:'/chuangwenJilu',
		name:'chuangwenJilu', 
		component: () => import('@/views/chuangwen/jilu.vue'),
		meta: {
			title: "创文助手"
		}
	},
	{
		path:'/chuangwenMsg',
		name:'chuangwenMsg', 
		component: () => import('@/views/chuangwen/msg.vue'),
		meta: {
			title: "创文助手"
		}
	},
	{
		path:'/yaoguanIndex',
		name:'yaoguanIndex', 
		component: () => import('@/views/yaopin-guankong/index.vue'),
		meta: {
			title: "药品管控-基础信息"
		}
	},
	{
		path:'/yaoguanAddtwo',
		name:'yaoguanAddtwo', 
		component: () => import('@/views/yaopin-guankong/add-stepTwo.vue'),
		meta: {
			title: "药品管控-扫描药品条码"
		}
	},
	{
		path:'/yaoguanAddThree',
		name:'yaoguanAddThree', 
		component: () => import('@/views/yaopin-guankong/add-stepThree'),
		meta: {
			title: "药品管控-上传处方证明"
		}
	},
	{
		path:'/yaoguanagreement01',
		name:'yaoguanagreement01', 
		component: () => import('@/views/yaopin-guankong/agreement.vue'),
		meta: {
			title: "隐私政策"
		}
	},
	{
		path:'/yaoguanagreement02',
		name:'yaoguanagreement02', 
		component: () => import('@/views/yaopin-guankong/agreement02.vue'),
		meta: {
			title: "用户服务协议"
		}
	},
	{
		path:'/yaoguanSpecial',
		name:'yaoguanSpecial', 
		component: () => import('@/views/yaopin-guankong/special.vue'),
		meta: {
			title: "药品管控-特殊人群登记"
		}
	},
	{
		path:'/yiyeyima',
		name:'yiyeyima', 
		component: () => import('@/views/yimatong/index.vue'),
		meta: {
			title: "一业一证"
		}
	},
	{
		path:'/yimatong',
		name:'yimatong', 
		component: () => import('@/views/yimatong/yimatong.vue'),
		meta: {
			title: "一业一证"
		}
	},
	{
		path:'/rencailogin',
		name:'rencailogin', 
		component: () => import('@/views/rencai/index/login.vue'),
		meta: {
			title: "东楚人才"
		}
	},
	{
		path:'/rencaiindex',
		name:'rencaiindex', 
		component: () => import('@/views/rencai/index/index.vue'),
		meta: {
			title: "东楚通人才网"
		}
	},
	{
		path:'/rencaisetUI',
		name:'rencaisetUI', 
		component: () => import('@/views/rencai/user/setUI.vue'),
		meta: {
			title: "我要找工作"
		}
	},
	
];

const router = new VueRouter({
	// mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	}
});

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */

	if (to.meta.title) {
		if (window.AlipayJSBridge) {
			checkAJB.setTitle(to.meta.title);
		} else {
			document.title = to.meta.title;
		}
	}
	next();
});
export default router;
